module.exports = __webpack_public_path__ + "img/01-4.e0b71366.png";